import { Component, OnInit, ViewChild, ElementRef, Inject, Directive, NgZone } from '@angular/core';

@Directive({
    selector: '[app-tooltip-container]',
})
export class TooltipContainerDirective {}

@Component({
    template: `
        <div class="tooltip-container" [ngStyle]="{ top: top, left: left, zIndex: zIndex }">
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./tooltip.component.css'],
})
export class TooltipComponent implements OnInit {
    top: string;
    left: string;
    zIndex: number;

    @ViewChild(TooltipContainerDirective, { read: ElementRef }) private tooltipContainer;

    constructor(@Inject('tooltipConfig') private config, private ngZone: NgZone) {}

    ngOnInit() {
        const host = this.config.host as HTMLElement;
        const tooltipPosition = this.config.tooltipPosition;

        // console.log(((this.tooltipContainer as ElementRef).nativeElement as HTMLElement).getBoundingClientRect());
        const { height: tooltipHeight } = ((this.tooltipContainer as ElementRef)
            .nativeElement as HTMLElement).getBoundingClientRect();

        const { offsetTop, offsetLeft } = host;
        const { height, width } = host.getBoundingClientRect();

        if (tooltipPosition === 'above') {
            this.top = `${offsetTop - tooltipHeight}px`;
        } else {
            this.top = `${offsetTop + height}px`;
        }
        this.left = `${offsetLeft + width}px`;

        // Make sure any new tooltip without a z index renders on top by setting its z-index higher
        if (this.config.zIndex) {
            this.zIndex = this.config.zIndex;
        } else {
            this.zIndex = document.getElementsByClassName('tooltip-container').length;
        }
    }
}
